import {injectable} from 'inversify';

import type {WsMessageModel} from './WsMessage.model';

import {BaseController} from '../Base/Base.controller';

@injectable()
export class WsMessageController extends BaseController<WsMessageModel> {
  constructor() {
    super();
  }
}
